// components/PublicOnlyRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";

interface PublicOnlyRouteProps {
  children: JSX.Element;
  isAuthenticated: boolean;
}

const PublicOnlyRoute = ({ children, isAuthenticated }: PublicOnlyRouteProps) => {
  return isAuthenticated ? <Navigate to="/" replace /> : children;
};

export default PublicOnlyRoute;
